<div class="driver-list container-full-height" infiniteScroll [scrollWindow]="false" (scrolled)="onScrollDown()"
  [infiniteScrollDistance]="2" [infiniteScrollThrottle]="300">
  @for (driver of driversInformation; track driver; let i = $index) {
    <div class="driver-list__item"
      (click)="selectDriver(driver, i)" [ngClass]="{'driver-list__item--selected': i === selectedIndex}" tabindex="0">
      <div class="driver-list__content">
        <div class="driver-list__image">
          <app-avatar [imageSrc]="driver.image" [name]="driver.name"></app-avatar>
        </div>
        <div class="driver-list__details d-flex flex-column gap-1">
          <span class="driver-list__name">{{ driver.name }}</span>
          <span class="driver-list__account">{{ driver.accountName }}</span>
        </div>
      </div>
      @if (notificationHandler(driver.driverLicenseRenewal, driver.professionalDriversPermitRenewalDate) && notificationCount > 0) {
        <div class="driver-list__notification driver-list__notification--visible"
          [ngbTooltip]="notificationMessage" placement="right">
          <div class="driver-list__notification-text">
            {{ notificationCount }}
          </div>
        </div>
      }
    </div>
  }
  <div class="d-flex justify-content-center align-items-center spinner-container">
    @if (isLoading && hasMoreData) {
      <span class="spinner-border"></span>
    }
  </div>
</div>